// extracted by mini-css-extract-plugin
module.exports = {"projectStyles":"styles_projectStyles__aVRe-","contentStyles":"styles_contentStyles__3ARoc","row":"styles_row__2jhsU","image":"styles_image__1rUl0"};